import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2, MessageCircle, Search, Store } from 'lucide-react';
import { RUNTIME_BACKEND_URL } from '../lib/backendUrl';
import { messageUrl } from '../lib/whatsapp';
import { findCategory } from '../lib/vitrinCategories';
import { ProductCard } from '../components/vitrin/ProductParts';

export default function PublicVitrinPage() {
  const { tenantId } = useParams();
  const [data, setData] = useState(null);
  const [cat, setCat] = useState('');
  const [cond, setCond] = useState('');
  const [q, setQ] = useState('');

  useEffect(() => {
    fetch(`${RUNTIME_BACKEND_URL}/api/hesap/public/vitrin/${tenantId}`).then(r => r.json())
      .then(d => { setData(d); document.title = `${d.seller?.name || 'Vitrin'} - Ürünler`; }).catch(() => setData({ seller: {}, items: [] }));
  }, [tenantId]);

  const custom = data?.seller?.custom_categories || [];
  const cats = useMemo(() => [...new Set((data?.items || []).map(i => i.cihaz_turu))], [data]);
  const items = (data?.items || []).filter(i => (!cat || i.cihaz_turu === cat) && (!cond || i.durum === cond)
    && (!q || `${i.marka} ${i.model}`.toLowerCase().includes(q.toLowerCase())));

  if (!data) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  const wa = messageUrl('whatsapp', data.seller.phone, 'Merhaba, vitrininizdeki ürünler hakkında bilgi almak istiyorum.');
  const chip = (active) => `px-4 py-1.5 rounded-full text-sm font-medium border transition-colors ${active ? 'bg-slate-900 text-white border-slate-900' : 'bg-white hover:bg-slate-100'}`;

  return (
    <div className="min-h-screen bg-slate-50" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="public-vitrin-page">
      <header className="bg-slate-900 text-white">
        <div className="max-w-6xl mx-auto px-4 py-10 flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-emerald-400 font-bold flex items-center gap-1.5"><Store className="h-3.5 w-3.5" /> Vitrin</p>
            <h1 className="text-3xl sm:text-4xl font-bold mt-2" data-testid="vitrin-seller-name">{data.seller.name || 'Ürünler'}</h1>
            <p className="text-slate-400 text-sm mt-1">{data.items.length} ürün satışta{data.seller.address ? ` · ${data.seller.address}` : ''}</p>
          </div>
          {wa && <a href={wa} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5b] font-semibold rounded-full px-5 py-2.5" data-testid="vitrin-whatsapp-btn"><MessageCircle className="h-4 w-4" /> WhatsApp</a>}
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-6 space-y-5">
        <div className="flex flex-wrap items-center gap-2">
          <div className="relative flex-1 min-w-[200px]">
            <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input value={q} onChange={e => setQ(e.target.value)} placeholder="Ürün ara..." className="w-full pl-9 pr-3 py-2 rounded-full border bg-white text-sm" data-testid="vitrin-search" />
          </div>
          {[['', 'Tümü'], ['sifir', 'Sıfır'], ['ikinci_el', '2. El']].map(([k, l]) => <button key={k} onClick={() => setCond(k)} className={chip(cond === k)} data-testid={`vitrin-cond-${k || 'all'}`}>{l}</button>)}
        </div>
        {cats.length > 1 && (
          <div className="flex flex-wrap gap-2">
            <button onClick={() => setCat('')} className={chip(!cat)} data-testid="vitrin-cat-all">Tüm Kategoriler</button>
            {cats.map(c => <button key={c} onClick={() => setCat(c)} className={chip(cat === c)} data-testid={`vitrin-cat-${c}`}>{findCategory(c, custom).label}</button>)}
          </div>
        )}
        {items.length === 0 ? <p className="text-center text-slate-500 py-16" data-testid="vitrin-empty">Ürün bulunamadı.</p> : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">{items.map(i => <ProductCard key={i.id} item={i} custom={custom} />)}</div>
        )}
      </main>
    </div>
  );
}
